import { mountedComponentReducer as mountedComponents } from './mountedComponents/mountedComponents.reducers'
import { configReducer as config } from './config/config.reducers'
import { userDeviceReducer as userDevice } from './userDevice/userDevice.reducers'
import { featureFlagReducer as featureFlag } from './featureFlags/featureFlags.reducers'
import { visibilityReducers as visibility } from './visibility/visibility.reducers'
import { currentUserReducer as currentUser } from './currentUser/currentUser.reducers'
import { messageUserReducer as messageUser } from './messageUser/MessageUser.reducers'
import { userStatsReducer as userStats } from './userStats/Stats.reducers'
import { logoReducer as logo } from './logo/logo.reducers'
import { postActionsReducer as postActions } from './postActions/postActions.reducers'
import { navigationReducer as navigation } from './navigation/navigation.reducers'
import { recommendedPostsReducer as recommendedPosts } from './recommendedPosts/recommendedPosts.reducers'
import { menuReducer as menu } from './menu/menu.reducers'
import { topAdReducer as topAd } from './topAd/topAd.reducers'

export const reducers = {
  mountedComponents,
  config,
  userDevice,
  featureFlag,
  visibility,
  currentUser,
  messageUser,
  userStats,
  logo,
  recommendedPosts,
  postActions,
  navigation,
  menu,
  topAd,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/reducers.js